import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function A() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('solar_panel_175w');
    const { locale } = useRouter();
    const IMGS = {
        pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717124202559/1.jpg',
        h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717124235883/1_M.jpg',
    };
    return (
        <div className={`sp-175w-A ${css['sp-175w-A']}`}>
            <div className="kv-img">
                <EFPicture src={IMGS.pc} srcPad={IMGS.h5} srcMobile={IMGS.h5} alt={t('A_title')} />
            </div>
            <div className="kv-box">
                <p className="kv-title">{t('A_title')}</p>
                <p className="kv-desc">{t('A_desc')}</p>
            </div>
        </div>
    );
}
